/**
 * @description: 虚拟礼物答谢报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="or-xld-report">
        <div class="xld-list">
            <div class="row row-margin">
                <label class="list-label-4">发送时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="xldTime">
                        <input type="text" class="form-control laydate-icon" v-model="xldStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="xldEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xldShop" data-placeholder="请选择门店"></select>
                </div>
                <div class="col-md-1 ct-col xld-tit-sel">
                    <select class="form-control" ref="xldperf_tit_sel">
                        <option value="1">收礼人艺名</option>
                        <option value="2">收礼人工号</option>
                        <option value="3">操作员工姓名</option>
                        <option value="4">操作员工工号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="xldperf_con_val" :placeholder="xldperf_con_phd">
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">答谢状态:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xld_status">
                        <option value="0">全部</option>
                        <option value="1">是</option>
                        <option value="-1">否</option>
                    </select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitXldTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getXldExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="xldList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="xldExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='xldExport_allcheck' @click='xldExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xldExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xldExport_checkModel' value="room_name">
                            <label>包厢号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xldExport_checkModel' value="receive_personnel_info">
                            <label>收礼人艺名（工号）</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xldExport_checkModel' value="receive_user_name">
                            <label>收礼人微信昵称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xldExport_checkModel' value="status_msg">
                            <label>答谢状态</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xldExport_checkModel' value="send_user_name">
                            <label>答谢客户微信昵称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xldExport_checkModel' value="create_time">
                            <label>发送时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xldExport_checkModel' value="operate_time">
                            <label>答谢时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xldExport_checkModel' value="operate_admin_info">
                            <label>操作员工</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='xldExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='xldExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                xldStartTime: "",
                xldEndTime: "",
                xldperf_con_val: "",
                xldperf_con_phd: "请输入收礼人艺名",
                xldperf_field: "1",
                xldExport_allcheck: false,
                c_xldExport_allcheck: false,
                xldExport_checkModel: [],
                xldExport_checkData: ['shop_name', 'room_name', 'receive_personnel_info', 'receive_user_name', 'status_msg', 'send_user_name', 'create_time', 'operate_time', 'operate_admin_info'],
                xldExport_type: 1,
            }
        },
        watch: {
            xldExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.xldExport_checkModel.length >= this.xldExport_checkData.length) {
                        this.xldExport_allcheck = true;
                        this.c_xldExport_allcheck = true;
                    } else {
                        this.xldExport_allcheck = false;
                        this.c_xldExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.xldStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.xldEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.innitDate(); // 日期
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 下拉选项
            $(_this.$refs.xldperf_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.xldperf_field = $(this).val();
                if(_this.xldperf_field == '1') {
                    _this.xldperf_con_phd = '请输入收礼人艺名';
                } else if(_this.xldperf_field == '2') {
                    _this.xldperf_con_phd = '请输入收礼人工号';
                } else if(_this.xldperf_field == '3') {
                    _this.xldperf_con_phd = '请输入操作员工姓名';
                } else if(_this.xldperf_field == '4') {
                    _this.xldperf_con_phd = '请输入操作员工工号';
                }
            });
            // 答谢状态
            $(_this.$refs.xld_status).select2({
                width: '100%',
                minimumResultsForSearch: -1,
                language: "zh-CN",
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.xldStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.xldEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.xldStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.xldEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.xldTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit : {
                        days : 31
                    },
                }, function(start, end, label) {
                    _this.xldStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.xldEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.xldShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.setShopDefaultTime(e.params.data.id)
                            });
                            $(_this.$refs.xldShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            _this.innitXldTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },



            // 虚拟礼物答谢报表表格
            innitXldTable: function() {
                let _this = this;
                $(_this.$refs.xldList).bootstrapTable('destroy');
                $(_this.$refs.xldList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getXldList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "130",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "room_name",
                        title: "包厢号",
                        width: "10%"
                    }, {
                        field: "receive_personnel_info",
                        title: "收礼人<br />艺名（工号）",
                        width: "10%"
                    }, {
                        field: "receive_user_name",
                        title: "收礼人<br />微信昵称",
                        width: "10%"
                    }, {
                        field: "status_msg",
                        title: "答谢状态",
                        width: "10%"
                    }, {
                        field: "send_user_name",
                        title: "答谢客户<br />微信昵称",
                        width: "10%"
                    }, {
                        field: "create_time",
                        title: "发送时间",
                        width: "100"
                    }, {
                        field: "operate_time",
                        title: "答谢时间",
                        width: "100"
                    }, {
                        field: "operate_admin_info",
                        title: "操作员工",
                        width: "10%"
                    }],
                });
            },
            // 获取虚拟礼物答谢报表数据
            getXldList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.xldShop).val(),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.xldStartTime,
                            "end_time": _this.xldEndTime,
                            "shop_id": shop_id,
                            "search_type": _this.xldperf_field,
                            "search_name": _this.xldperf_con_val,
                            "status": $(_this.$refs.xld_status).val()
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGhiUserAcknowledge",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getXldExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/ghiUserAcknowledgeExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.xldExport_checkModel = data.response.result.export_fields;
                                _this.xldExport_type = data.response.result.export_type;
                            } else {
                                _this.xldExport_checkModel = _this.xldExport_checkData;
                                _this.xldExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.xldExport_alert)
                }, function() {
                    _this.exportXldList();
                });
            },
            // 导出字段全选
            xldExportCheckedAll: function() {
                let _this = this;
                _this.xldExport_allcheck = _this.c_xldExport_allcheck;
                if(!_this.xldExport_allcheck) { // 实现全选
                    _this.xldExport_checkModel = [];
                    _this.xldExport_checkData.forEach(function(item) {
                        _this.xldExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.xldExport_checkModel = [];
                }
            },
            // 导出虚拟礼物答谢报表
            exportXldList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.xldShop).val();
                let export_fields = JSON.stringify(_this.xldExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport/ghiUserAcknowledgeExport?" +
                    "&start_time=" + _this.xldStartTime +
                    "&end_time=" + _this.xldEndTime +
                    "&shop_id=" + shop_id +
                    "&search_type=" + _this.xldperf_field +
                    "&search_name=" + _this.xldperf_con_val +
                    "&status=" + $(_this.$refs.xld_status).val() +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.xldExport_type;
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .xld-list {
        .xld-tit-sel {
            width: 125px;
            padding: 0;
        }
    }
</style>